import { NAVBUTTON_CLICK, SUBMENUBUTTON_CLICK, LINK_CLICK, PALETTE_SET_OPEN } from './actionTypes';

export const navbutton_click = (id, link, title, linktext, icon, url) => {
  let action = {
    type: NAVBUTTON_CLICK,
    payload: { id, link, title, icon, url },
  };
  return action;
};

export const submenubutton_click = (id, link, title, icon, url, navButton) => {
  let action = {
    type: SUBMENUBUTTON_CLICK,
    payload: { id, link, title, icon, url, navButton },
  };
  return action;
};

// Global record search palette (CD-5425). Redux rather than local state because the palette mounts
// at app.js level while its mouse entry point lives inside BravoSidebar -> NavSearchFlyout, so the
// two cannot share component state. seedText carries a first keystroke forwarded from that control.
export const palette_set_open = (open, seedText = '') => {
  let action = {
    type: PALETTE_SET_OPEN,
    payload: { open, seedText },
  };
  return action;
};

export const link_click = (link, title, icon, menuitem, submenuButton = 0, url = '') => {
  let action = {
    type: LINK_CLICK,
    payload: { link, title, icon, menuitem, submenuButton, url },
  };
  return action;
};
